module.exports = __webpack_public_path__ + "static/media/logo-banorte.edb32a54.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/logo-banorte.png
 ** module id = 799
 ** module chunks = 0
 **/